import React from 'react';
// import { Elements } from '@stripe/react-stripe-js';

// import {loadStripe} from '@stripe/stripe-js'
// const stripePromise = loadStripe('pk_test_51OtB4lKGib0qk5h5vL1qfNXbcp6F0uIOoHcJuxdS1nGT29QxTtykwSCs0bUM3shAbkfM2GmakqymS2uRWSMTOrbh00xQr8dq3Q');




const Services = () => {
  // // payment integration
  // const handleStripePayment = () => {
  //   // Redirect to payment page
  //   // You can navigate using React Router or any other method
  //   // For example:
  //   window.location.href = '/paymentform';
  // };


    // const makePayment = async () => {
    //   try {
    //     const response = await fetch('/api/payment', {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //       },
    //       body: JSON.stringify({ amount: 100 }),
    //     });
    //     const data = await response.json();
    //     console.log(data);
    //   } catch (error) {
    //     console.error(error);
    //   }
    // };
    return (
        <div>
            <div className="container-fluid p-0 mb-5" >
                <div className="row " >
                    <div className="col-md-12  position-relative bg-dark text-white py-5" style={{backgroundImage: `url('https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg?auto=compress&cs=tinysrgb&w=600')`, backgroundSize: 'cover', backgroundPosition: 'center' ,zIndex: 1, }}>
                    <div className="position-absolute top-0 start-0 w-100 h-100 opacity-50" style={{ zIndex: -1, backgroundColor: "#ffa500" }}></div>

                        <div className="text-left py-5 px-5" style={{ height: 350  }}>
                        <h1 className='text-white py-5 pb-3' style={{ zIndex: 100,  }}>Services</h1>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div className="container my-5">
                
                <h1 className="text-center mb-5">Our Services</h1>

      <div className='row mb-5'>
        <div className='col-md-6 p-4 text-left'>
        <h1>From Anywhere</h1>
<h3>Donate: If you use this site regularly and would like to help keep the site on the Internet, please consider donating </h3>

<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat Donate: If you use this site regularly and would like to help keep the site on the Internet, please consider donating a small sum to help pay for the hosting and bandwidth bill </p>       </div>
<div className='col-md-6 ' style={{ borderRadius: '20px 0 0 0' }}>
    <img src="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=600" alt="About" className="img-fluid rounded" />
</div>


    
      </div>
     
 
      

                <div className="row mt-5">

                    <h2 className='my-5 pt-5'> Enjoy Perks & Rewards</h2>
                    <div className="col-md-4 mb-4">
                        <div className="card">
                            <div className="card-body">
                            <img src="https://images.pexels.com/photos/1595385/pexels-photo-1595385.jpeg?auto=compress&cs=tinysrgb&w=600" alt="About" class="img-fluid" />

                                <h5 className="card-title">Product 1</h5>
                                <p className="card-text">Description of product 1.</p>
                                <a href="#"  className="btn btn-primary" style={{  backgroundColor: "#FFA500" } }>Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">

                        <div className="card">
                            <div className="card-body">
                            <img src="https://images.pexels.com/photos/1595385/pexels-photo-1595385.jpeg?auto=compress&cs=tinysrgb&w=600" alt="About" class="img-fluid" />

                                <h5 className="card-title">Product 2</h5>
                                <p className="card-text">Description of product 2.</p>
                                <a href="#" style={{  backgroundColor: "#FFA500" } }  className="btn btn-primary">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 mb-4">
                        <div className="card">
                            <div className="card-body">
                            <img src="https://images.pexels.com/photos/1595385/pexels-photo-1595385.jpeg?auto=compress&cs=tinysrgb&w=600" alt="About" class="img-fluid" />

                                <h5 className="card-title">Product 3</h5>
                                <p className="card-text">Description of product 3.</p>
                                <a href="#"  style={{  backgroundColor: "#FFA500" } } className="btn btn-primary">Learn More</a>
                            </div>
                        </div>
                    </div>
                </div>
               
                {/* Additional space for more services */}
            </div>

            
 <div className='row p-5 text-white mt-5 text-left' style={{ backgroundColor: "#ffa500", paddingTop: '20px' , paddingBottom: "70px" }}>
    <div className='col-md-6 p-4 text-left'>
        <h1 className='text-left'>Own Your Office Environment</h1>
        <h3>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form</h3>
        <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.</p>
        <a href="#" className="btn btn-secondary">Learn More</a>
    </div>
    <div className='col-md-6' style={{ borderRadius: '20px 0 0 0' }}>
        <img src="https://images.pexels.com/photos/1595385/pexels-photo-1595385.jpeg?auto=compress&cs=tinysrgb&w=600" alt="About" className="img-fluid rounded" />
    </div>
</div>



    
      </div>

           

      

        
    );
}

export default Services;
